import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-12" }
const _hoisted_3 = { class: "col-span-full" }
const _hoisted_4 = { class: "grid grid-cols-1" }
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-2 gap-6"
}
const _hoisted_7 = { class: "col-span-1" }
const _hoisted_8 = { class: "col-span-1" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import TabComponent from '@/components/TabComponent.vue';
import FormSection from '@/components/FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import PageLoader from '@/components/PageLoader.vue';
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ToggleSwitch from '@/components/inputs/ToggleSwitch.vue';
import TextInput from '@/components/inputs/TextInput.vue';

import Rider from '@/classes/Rider';
import { daysOfTheWeek } from '@/helpers/PackageRiderHelper'
import { useRoute } from 'vue-router';
import { ref, onMounted } from 'vue';
import { checkForInvalidResponse } from '@/helpers/PageHelper';
import { replaceDashWithBackslash } from '@/helpers/PackageRiderHelper';
import { Logger } from 'sass';


/**
 * ********************************
 * Interface 
 * ********************************
 */

interface selectedDaysInterface {
    day: number,
    start_time: string,
    end_time: string,
}
 

/**
 * ********************************
 * Data 
 * ********************************
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'SchedulePage',
  setup(__props) {

const route        = useRoute();
const isWholeday   = ref<boolean>(false);
const loader       = ref<boolean>(false)
const errors       = ref<object>([]);
const riderName    = ref(route.params.name);
const showSuccess  = ref<boolean>(false);
const showError    = ref<boolean>(false);
const errorMsg     = ref<boolean>(false);
const selectedDays = ref<selectedDaysInterface[]>([])

const time = ref<{
    start_time:string, 
    end_time:string
}>({
    start_time: '', 
    end_time: ''
});

const days = daysOfTheWeek

const tabs: { name: string, href: string, allowed: boolean }[] = [
    {
        name: 'Information',
        href: `/contents/riders/show/${riderName.value}`,
        allowed: true
    },
    {
        name: 'Schedule',
        href: `/contents/riders/schedule/${riderName.value}`,
        allowed: true
    },
];

/**
 * ********************************
 * Helper Methods 
 * ********************************
 */
const addDay = (val: any) => {
    const index:number = getIndex(val)

    if(index > -1) {
        selectedDays.value.splice(index, 1);
    } else {
        selectedDays.value.push({
            day: val,
            start_time: time.value?.start_time,
            end_time: time.value?.end_time,
        });
    }
}


const addAll = () => {
    if(selectedDays.value.length >= 7){
        selectedDays.value = [];
    } else {
        daysOfTheWeek.forEach(day => {
            selectedDays.value.push({
                day: day.value,
                start_time: time.value?.start_time,
                end_time: time.value?.end_time,
            });
        });
    }
}

const getIndex = (val: number|string):number => {
    return selectedDays.value.findIndex((day: any) => day.day === val) 
}


/**
 * ********************************
 * Submit Form 
 * ********************************
 */
 const submit = async () => {
    try {
        const payload = {
            rider_name: replaceDashWithBackslash(riderName.value),
            is_wholeday : isWholeday.value,
            days: selectedDays.value,
        };

        await Rider.updateRiderSchedule(payload);
        loader.value      = false;
        showSuccess.value = true;

        fetchRiderSchedule();

    } catch (err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err.response?.data?.message;

        if (err.response?.status === 422) {
            errors.value = err.response.data.errors;
        }
    }
};
/**
 * ********************************
 * Fetch Rider Schedule 
 * ********************************
 */
const fetchRiderSchedule = async () => {
    loader.value = true;

    try {
        const { data } = await Rider.showRiderSchedule(replaceDashWithBackslash(riderName.value))

        loader.value = false;

        time.value = data.time;
        const schedule = data.schedule
        
        if(schedule){   

            isWholeday.value = schedule.is_wholeday == true
            selectedDays.value = schedule?.days || []
        }
    }
    catch(error) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = error.response?.data.message;

        if(error.response?.status == 422) {
            errors.value = error.response?.data.errors;
        }
        
        checkForInvalidResponse(error, '/contents/riders')
    }
    finally {
        loader.value = false;
    }
}

onMounted(() => fetchRiderSchedule())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: "View Rider",
    "show-back": "",
    backUrl: "/contents/riders"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, { tabs: tabs })
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FormSection, null, {
          title: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode(" Schedule Information ", -1)
          ]))]),
          description: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode(" Relevant data and other details ", -1)
          ]))]),
          form: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (!loader.value)
                ? (_openBlock(), _createBlock(ToggleSwitch, {
                    key: 0,
                    value: isWholeday.value,
                    modelValue: isWholeday.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isWholeday).value = $event)),
                    onChange: _cache[1] || (_cache[1] = (value) =>(isWholeday.value = value)),
                    label: "Whole Day"
                  }, null, 8, ["value", "modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-1 text-sm text-gray-900" }, "Booking Day/s", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(CheckboxInput, {
                    id: "all",
                    label: "All",
                    rounded: false,
                    "is-checked": selectedDays.value.length == 7,
                    "text-color": "text-darkgray-800",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (addAll()))
                  }, null, 8, ["is-checked"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(days), (i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: i.label
                    }, [
                      _createVNode(CheckboxInput, {
                        id: i.label,
                        label: i.label,
                        rounded: false,
                        "is-checked": getIndex(i.value) !== -1,
                        "text-color": "text-darkgray-800",
                        onChange: ($event: any) => (addDay(i.value))
                      }, null, 8, ["id", "label", "is-checked", "onChange"]),
                      (i.value != 'all' && getIndex(i.value) !== -1 && !isWholeday.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(TextInput, {
                                type: "time",
                                id: i.value + '_start_time',
                                name: i.value + '_start_time',
                                label: "Start Time",
                                placeholder: "Start Time",
                                step: 60,
                                modelValue: selectedDays.value[getIndex(i.value)].start_time,
                                "onUpdate:modelValue": ($event: any) => ((selectedDays.value[getIndex(i.value)].start_time) = $event)
                              }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(TextInput, {
                                type: "time",
                                id: i.value + '_end_time',
                                name: i.value + '_end_time',
                                label: "End Time",
                                placeholder: "End Time",
                                step: 60,
                                modelValue: selectedDays.value[getIndex(i.value)].end_time,
                                "onUpdate:modelValue": ($event: any) => ((selectedDays.value[getIndex(i.value)].end_time) = $event)
                              }, null, 8, ["id", "name", "modelValue", "onUpdate:modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ])
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-span-6" }, null, -1))
          ]),
          actions: _withCtx(() => [
            (_ctx.$hasPermission('update-package-and-rider-schedule'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  onClick: submit
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Save Changes ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Rider Schedule",
        content: "Rider Schedule updated Successfully!"
      }, null, 8, ["show"]),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Warning",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})